var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{directives:[{name:"tippy",rawName:"v-tippy",value:({ placement: 'top', arrow: true }),expression:"{ placement: 'top', arrow: true }"}],staticClass:"mx-2",attrs:{"content":"<span class='font-size-14'>Double click here to update.<br>Don't forget to press enter.</span>"}},[_vm._v("mdi-progress-question")])
}
var staticRenderFns = []

export { render, staticRenderFns }